import { SvgIconProps } from './icon-props';

export default function IconChevronUp({ height = 8, width = 16, fill = '#1F1F1F' }: SvgIconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 16 8"
			fill="none"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M16 8.00012L8 0.00012207L0 8.00012H1.6L8 1.60012L14.4 8.00012H16Z"
				fill={fill}
			/>
		</svg>
	);
}
